export default "__VITE_ASSET__Bl7h3oJE__"